module.exports = __webpack_public_path__ + "static/media/object.b946d184.gif";